// @ts-strict-ignore
import Cleave from 'cleave.js/react';
import get from 'lodash/get';
import React from 'react';

interface ICleaveOptions {
  blocks?: Array<number>;
  date?: Boolean;
  datePattern?: Array<string>;
  delimiter?: string;
  numericOnly?: Boolean;
  placeholder?: string;
  submit_delimiter?: Boolean;
}

export interface IProps {
  changeHandler: () => void;
  extraOptions?: { className: string; readOnly: Boolean | string };
  fieldName: string;
  fieldKey: string;
  fieldValue: string;
  formData: any;
  helperText: string;
  cleaveOptions: ICleaveOptions;
}

export default function CleaveInput({
  changeHandler,
  extraOptions,
  fieldKey,
  fieldValue,
  formData,
  helperText = '',
  cleaveOptions: options,
}: IProps) {
  return (
    <>
      <Cleave
        autoComplete="stopItChrome"
        id={fieldKey}
        key={fieldKey}
        name={fieldKey}
        onChange={changeHandler}
        options={options}
        placeholder={options.placeholder}
        type="text"
        value={fieldValue || get(formData, fieldKey)}
        {...(extraOptions || {})}
      />
      <div className="smaller-text" key={`smaller-text-${fieldKey}`}>
        <i className="grey">{helperText}</i>
      </div>
    </>
  );
}
